import React, { useEffect, useState } from "react";
import apiClient from "../../../services/apiClient";
import { getHeaders } from "../../ApiHeaders/apiHeaders";
import { datadogLogs } from "@datadog/browser-logs";
import { datadogRum } from "@datadog/browser-rum";
import Dropdown from "../DropDown";
import { useAssetContext } from "../../DataContext/AssetContext";

const granularityRules: Record<string, string[]> = {
  day_ahead: ["5minute", "15minute", "hour", "day"],
  today: ["5minute", "15minute", "hour", "day"],
  yesterday: ["5minute", "15minute", "hour", "day"],
  minus_7d: ["5minute", "15minute","hour", "day"],
  minus_30d: ["5minute", "15minute","hour", "day","week"],
  mtd: ["5minute", "15minute","hour", "day","week"],
  ytd: ["5minute", "15minute","hour", "day","week","month"],
  custom: ["5minute", "15minute", "hour", "day", "week", "month"],
};

interface GranularityDropdownProps {
  selectedValue: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  className?: string;
}

const GranularityDropdown: React.FC<GranularityDropdownProps> = ({
  selectedValue,
  onChange,
  disabled = false,
  className = "w-full p-1 sm:p-1 pl-4 pr-16 border border-gray-300 rounded-lg  bg-[#f9f9f9] text-gray-900 shadow-inner text-xs md:text-base appearance-none",
}) => {
  const { selectedDateRange } = useAssetContext();
  const [allGranularities, setAllGranularities] = useState<
    { label: string; value: string }[]
  >([]);
  const [loading, setLoading] = useState(true);
  const [filteredGranularities, setFilteredGranularities] = useState<
    { label: string; value: string }[]
  >([]);

  useEffect(() => {
    const fetchGranularities = async () => {
      try {
        const cached = sessionStorage.getItem("granularities");
        if (cached) {
          const parsed = JSON.parse(cached);
          setAllGranularities(parsed);
          return;
        }

        const headers = await getHeaders();
        datadogRum.addAction("Fetching Granularities", {
          url: "/ref-data/frequencies",
        });
        const response = await apiClient.get("/ref-data/frequencies", {
          headers,
        });

        if (response.data?.response?.data) {
          const apiData = response.data.response.data;
          const formatted = Object.entries(apiData).map(
            ([label, value]) => ({
              label,
              value: String(value),
            })
          );

          setAllGranularities(formatted);
          sessionStorage.setItem("granularities", JSON.stringify(formatted));
      } else {
        console.error("Unexpected API response format:", response.data);
        datadogLogs.logger.warn("Unexpected API response format", {
          data: response.data,
        });
      }
    } catch (error) {
      console.error("Error fetching Granularities:", error);
      datadogLogs.logger.error("Error fetching Granularities", {
        error: (error as Error)?.message,
      });
    } finally {
      setLoading(false);
    }
  };

    fetchGranularities();
}, []);


 
  useEffect(() => {
    if (!selectedDateRange || allGranularities.length === 0) return;

    const isCustomDateRange = /^\d{4}-\d{2}-\d{2}\s*-\s*\d{4}-\d{2}-\d{2}$/.test(selectedDateRange);
    const lookupKey = isCustomDateRange ? "custom" : selectedDateRange;
    const allowedValues = granularityRules[lookupKey] || [];

    const filtered = allGranularities.filter((f) =>
      allowedValues.includes(f.value)
    );

    setFilteredGranularities(filtered);

    if (!allowedValues.includes(selectedValue)) {
      onChange("");
    }
  }, [selectedDateRange, allGranularities]);

  return (
    <Dropdown
      options={filteredGranularities}
      selectedValue={selectedValue}
      onValueChange={onChange}
      disabled={disabled}
      className={className}
      placeholder="Select Granularity"
    />
  );
};

export default GranularityDropdown;

// Stepline for volum
// curved line for price
//stacked for bar chart
//
